// extracted by mini-css-extract-plugin
module.exports = {"banner":"app-banner_banner__2S_Kx"};